import _ from 'lodash';

const ChangeLang = () => {
  const obj = {};

  const addCacheBuster = (path) => {
    const separator = path.includes('?') ? '&' : '?';
    const timestamp = new Date().getTime();
    return `${path}${separator}v=${timestamp}`;
  };

  obj.load = (path = "./lang/english.json") => {
    const url = addCacheBuster(path);
    fetch(url)
      .then(response => response.json())
      .then(json => {
        window.app_setLanguage({ selectedLanguage: path, data: json });
      })
      .catch(error => {
        console.error('Error loading the JSON:', error);
      });
  };

  obj.change = (path = "./lang/english.json") => {
    localStorage.setItem("language", path);
    const url = addCacheBuster(path);
    fetch(url)
      .then(response => response.json())
      .then(json => {
        window.app_setLanguage({ selectedLanguage: path, data: json });
      })
      .catch(error => {
        console.error('Error loading the JSON:', error);
      });
  };

  obj.get = (path) => {
    try {
      return _.get(window?.app_language?.data, path);
    } catch (error) {
      console.error('Error accessing language data:', error);
      return undefined;
    }
  };

  return obj;
};

export const changeLang = ChangeLang();
